import { render, staticRenderFns } from "./domain-company-details-section.html?vue&type=template&id=952baa06&scoped=true&"
import script from "./domain-company-details-section.js?vue&type=script&lang=js&"
export * from "./domain-company-details-section.js?vue&type=script&lang=js&"
import style0 from "./domain-company-details-section.scss?vue&type=style&index=0&id=952baa06&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "952baa06",
  null
  
)

export default component.exports